/* eslint-disable lodash/prefer-lodash-method */
import { ThunkDispatch, EmptyObject, AnyAction } from '@reduxjs/toolkit';
import * as FileSaver from 'file-saver';
import moment from 'moment';
import { Dispatch } from 'react';
import { PersistPartial } from 'redux-persist/es/persistReducer';
import { PrivateSalesExportExcelResponseType } from '../../../../services/PrivateSales/types';
import {
  PrivateSalesFiltersType,
  privateSalesListSlice,
} from '../../../../stores';
import { delay } from '../../../../utils/Helpers';

export const exportPrivateSalesToCSV = async (
  apiData: PrivateSalesExportExcelResponseType,
  filters: PrivateSalesFiltersType | null,
  dispatch: ThunkDispatch<EmptyObject & PersistPartial, undefined, AnyAction> &
    Dispatch<AnyAction>,
  worker: (
    apiData: PrivateSalesExportExcelResponseType,
    filters: PrivateSalesFiltersType | null,
  ) => Promise<string>,
): Promise<void> => {
  dispatch(privateSalesListSlice.actions.setPrivateSalesExportPercentage(20));

  const handledApiData = await worker(apiData, filters);
  dispatch(privateSalesListSlice.actions.setPrivateSalesExportPercentage(60));

  const fileType = 'data:text/csv;charset=utf-8;';
  const fileExtension = '.csv';
  dispatch(privateSalesListSlice.actions.setPrivateSalesExportPercentage(100));
  await delay(100);

  const blob = new Blob([handledApiData], {
    type: fileType,
  });

  FileSaver.saveAs(
    blob,
    `vendas-${moment().format('yyyy-MM-DD_hh-mm')}` + fileExtension,
  );

  return;
};

/* Handler executado dentro de um Web Worker via @koale/useworker.
   Mantém-se autocontido (sem optional chaining ?., sem nullish coalescing ??,
   sem helpers ou imports externos), porque o Terser do build de produção
   serializa apenas o corpo da função via toString() e referências fora do
   escopo (ex.: kn helper) ficam indefinidas no contexto do Worker
   (https://github.com/alewin/useWorker/issues/189). */
export const handleApiDataPrivateSalesToCSV = (
  apiData: PrivateSalesExportExcelResponseType,
  filters: PrivateSalesFiltersType | null,
) => {
  const auxDrivers: any[] = [];
  const safeDrivers = filters && filters.drivers ? filters.drivers : [];

  let handledApiData = `"Ticket";"Situação";"Placa";"Metodo de pagamento";"Hora registro";"Hora inicial";"Estacionamento";"Motorista";"Valor";\r\n`;

  // eslint-disable-next-line lodash/prefer-lodash-method
  apiData.map((item) => {
    const formatDateTime = (dateTime: string) => {
      return (
        dateTime[8] +
        dateTime[9] +
        '/' +
        dateTime[5] +
        dateTime[6] +
        '/' +
        dateTime[0] +
        dateTime[1] +
        dateTime[2] +
        dateTime[3] +
        ' ' +
        dateTime.slice(11)
      );
    };

    const registerDateTime = formatDateTime(item.registerDateTime);
    const startDateTime = formatDateTime(item.startDateTime);

    if (item.driverId && auxDrivers[item.driverId] === undefined) {
      // eslint-disable-next-line lodash/prefer-lodash-method
      auxDrivers[item.driverId] = safeDrivers.find((auxItem) => {
        return auxItem.id === item.driverId;
      });
    }

    const driver = item.driverId ? auxDrivers[item.driverId] : null;

    handledApiData =
      handledApiData +
      `"${item.parkingTicketId}";"${item.situation}";"${item.plate}";"${
        item.paymentType
      }";"${registerDateTime}";"${startDateTime}";"${
        item.privateParkingName
      }";"${driver === undefined ? 'Indisponível' : driver}";"${
        item.price ? item.price.toString().replace('.', ',') : '0'
      }";\r\n`;
  });

  return handledApiData;
};
